import { render, staticRenderFns } from "./PlanoCliente.vue?vue&type=template&id=107d9bf4"
import script from "./PlanoCliente.vue?vue&type=script&lang=js"
export * from "./PlanoCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports